<template>
    <div >
        <TWtype1 v-if="this.data.page_type == 1" v-bind:elems="data" />
        <TWtype2 v-else-if="this.data.page_type == 2" v-bind:elems="data" v-bind:index="index" v-bind:columnId="columnId"/>
        <TWtype3 v-else-if="this.data.page_type == 3" v-bind:elems="data" v-bind:index="index" v-bind:columnId="columnId"/>
        <TWtype4 v-else-if="this.data.page_type == 4" v-bind:elems="data" v-bind:index="index" v-bind:columnId="columnId"/>
        <TWtype5 v-else-if="this.data.page_type == 5" v-bind:elems="data" v-bind:index="index" v-bind:columnId="columnId"/>
    </div>
</template>

<script>
import TWtype1 from "../tongwei/oneNews.vue";
import TWtype2 from "../tongwei/TwoNews.vue";
import TWtype3 from "../tongwei/ThreeNews.vue";
import TWtype4 from "../tongwei/FourNews.vue";
import TWtype5 from "../tongwei/FiveNews.vue";
export default {
  props: {
    
    data: Object,
    index: [Number, String],
    columnId:[Number, String]
  },
  components: {
    TWtype1,
    TWtype2,
    TWtype3,
    TWtype4,
    TWtype5,
  },

};
</script>

<style>
</style>